import React, { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { TransparentModal } from '@sg/garnish';

import { useNavigateBack } from '../../navigation';
import { DeliveryOrderInFlightContent } from './DeliveryOrderInFlightContent';

export const DeliveryOrderInFlightScreen = () => {
  const router = useRouter();
  const { orderId } = useLocalSearchParams<{ orderId?: string }>();
  const navigateBack = useNavigateBack();

  const handleClose = useCallback(() => {
    navigateBack();
  }, [navigateBack]);

  const handleOrderStatus = useCallback(() => {
    router.replace({
      pathname: '/order-status/[orderId]',
      params: { orderId: orderId ?? '' },
    });
  }, [router, orderId]);

  return (
    <TransparentModal testID="delivery-order-in-flight" size="medium" onClose={handleClose}>
      <DeliveryOrderInFlightContent onClose={handleClose} onOrderStatus={handleOrderStatus} />
    </TransparentModal>
  );
};
